<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2023-10-09 16:20:58
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-10-16 17:15:19
 * @FilePath: /chaoyongtuan/src/views/teamManage/performanceManage/components/tableCells/dinCell.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="price-cell fz-14"><span v-if="column.showPriceTag">¥</span>{{ row[column.key] | formatPrice2 }}</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin.js';
export default {
	mixins: [mixin],
	components: {},
};
</script>
<style lang="less" scoped>
.price-cell {
	font-family: 'Barlow-Medium';
	color: @color-text-primary;
}
</style>
